@if (config && config.show) {
  <div class="dialog-overlay"></div>
  <div class="dialog-container">
    <div id="dialog"
         cdkDrag
         cdkDragBoundary=".drag-limit"
         [style.max-height]="'90%'"
         (mousedown)="onClick()"
    >
      <header *ngIf="config.title" cdkDragHandle>
        <div id="title">
          <span class="text-white">{{ config.title | translate }}</span>
        </div>
        <div id="close" (click)="onClose()">
          <i class="fas fa-times"></i>
        </div>
      </header>
      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
